// sagas.js
import { takeLatest, put } from 'redux-saga/effects';
import { getAllAdminWalletsDataError, getAllAdminWalletsDataSuccess, getAllWalletRefundDataError, getAllWalletRefundDataSuccess } from './action';
import { GET_ALL_ADMIN_WALLET_DATA, GET_ALL_WALLET_REFUND_DATA } from '../actionTypes';
import { getAllAdminWallet, getAllCompanys, getAllDealers, getAllWalletRefund } from '../../api';

function* getAllAdminWalletSaga(action) {
  try {
    const { setTotalData,settotalPage,getCount } = action.payload;
    const data = yield getAllAdminWallet()
    const companiesData = yield getAllCompanys()
      const temp = []
      yield data.data.result.map(ele => {
        const comp = companiesData.data.result.filter(item => item.company_id === ele.company_id)
        temp.push({ ...ele, company_name: comp[0].client_company_name })
      })
      // setDataHolder(temp)
      setTotalData(temp)
      settotalPage(Array.from({ length: Math.ceil(temp.length / 10) }, (v, i) => i + 1))
      const walletData = getCount(1, temp)
      if (walletData) {
        yield put(getAllAdminWalletsDataSuccess(walletData));
        }
  } catch (error) {
    yield put(getAllAdminWalletsDataError(error.response.data.error)); 
  }
}


function* getAllWalletRefundSaga(action) {
  try {
    const { setTotalData,settotalPage,getCount } = action.payload;
    const data = yield getAllWalletRefund()
    const companiesData = yield getAllCompanys()
      const temp = []
      const mainTemp = []
      yield data.data.result.map(ele => {
        const comp = companiesData.data.result.filter(item => item.company_id === ele.company_id)
        temp.push({ ...ele, company_name: comp[0].client_company_name })
      })
      const dealerData = yield getAllDealers()
      yield temp.map(ele => {
          const dealer = dealerData.data.result.filter(item => item.dealership_id === ele.dealership_id)
          mainTemp.push({ ...ele, dealership_name: dealer.length ? dealer[0].dealer_name : "not found" })
        })
        setTotalData(mainTemp)
        settotalPage(Array.from({ length: Math.ceil(mainTemp.length / 10) }, (v, i) => i + 1))
      const walletRefundData = getCount(1, mainTemp)
      if (walletRefundData) {
        yield put(getAllWalletRefundDataSuccess(walletRefundData));
        }
  } catch (error) {
    yield put(getAllWalletRefundDataError(error.response.data.error)); 
  }
}


export function* watchNavisionData() {
  yield takeLatest(GET_ALL_ADMIN_WALLET_DATA, getAllAdminWalletSaga);
  yield takeLatest(GET_ALL_WALLET_REFUND_DATA, getAllWalletRefundSaga);
}

